module.exports = __webpack_public_path__ + "src/img/checkerOn.fe949c79.svg";